import config from './../modules/Config/Config';
import tracker from './tracker';

// Keep track of the track calls so that they do not get duplicated
var trackedIds = [];

// If there is at least one Pixel define, then export a tracker
export default tracker({
  name: 'Facebook Pixel',
  conf: config && config.facebookPixel || [],
  library: function libFn() {

    // Load the Facebook Pixel library
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function()
    {n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)}
    ;if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s && s.parentNode.insertBefore(t,s)}(window,
    document,'script','//connect.facebook.net/en_US/fbevents.js');
  },
  initialize: function initFn(trackingOptions) {

    // Initialize the tracking code with Facebook
    fbq('init', trackingOptions.key);
  },
  track: function trackFn(trackId, trackingArgs) {

    // Only send an event if we have not seen this event yet
    if (trackedIds.indexOf(trackId) === -1) {

      // Push this event on to the list of known events
      trackedIds.push(trackId);

      // Finally call the underlying Facebook Pixel function to track
      window.fbq.apply(window, trackingArgs);
    }
  }
})